import UserGarageButton from './UserGarageButton'
import userGarageButtonContainer from './userGarageButtonContainer'

export default userGarageButtonContainer(UserGarageButton)
